const INITIAL_STATE = {
  play: false,
  videoOptions: {
    watchTime: 0,
    video: '',
    index: 0
  },
  viewedVideos: [],
  allVideos: []
}

export default function videoReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'PLAY_PAUSE': 
      return {
        ...state,
        play: action.play
      }
    case 'SET_WATCH_TIME': 
      return {
        ...state,
        videoOptions: { 
          watchTime: action.watchTime,
          video: action.video,
          index: action.index
        }
      }
    case 'SET_ALL_VIDEOS': 
      return {
        ...state,
        allVideos: action.allVideos
      }
    case 'SET_VIEWED_VIDEOS': 
      return {
        ...state,
        viewedVideos: action.viewedVideos
      }
    default:
      return state;
  }
}
